<template lang="pug">
.parallax-background.w-100.h-100
    .contents(:style="`transform:translateY(${offset}px);`")
        slot
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ParallaxBackground",
  setup() {
    let observer;
    return { observer };
  },
  data() {
    return {
      watchScroll: false,
      offset: 0,
    };
  },
  methods: {
    onScroll() {
      if (!this.watchScroll) return;
      const innerElement = this.$el.querySelector(".contents");
      if (!innerElement) return;
      const distanceToTop = innerElement.getBoundingClientRect().top;
      if (distanceToTop > 0) {
        this.offset = 0;
        return;
      }
      this.offset = Math.round(distanceToTop * -0.5);
    },
  },
  created() {
    this.observer = new IntersectionObserver(([entry]) => {
      this.watchScroll = entry.isIntersecting;
    });
  },
  mounted() {
    const innerElement = this.$el.querySelector(".contents");
    if (!innerElement) return;
    this.observer.observe(innerElement);
    window.addEventListener("scroll", this.onScroll);
  },
  unmounted() {
    const innerElement = this.$el.querySelector(".contents");
    if (!innerElement) return;
    this.observer.unobserve(innerElement);
    window.removeEventListener("scroll", this.onScroll);
  },
});
</script>
<style lang="scss">
.parallax-background {
  .contents {
    & > * {
      position: relative;
      left: 50%;
      transform: translate(-50%, 0%);
    }
  }
}
</style>
